import { Stack } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: gray;
`;

export const TextFieldCustom = styled.div`
  width: 100%;
  border-bottom: 1px solid gray;
  padding: 10px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: 10px;
  text-align: left;
`;
export const StyledTypographyUser = styled.div`
  // min-height: 35px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 2;
  // -moz-box-orient: vertical;
  background: #04c1f3;
  display: inline-block;
  width: auto;
  max-width: 80%;
  min-width: 160px;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border-bottom-right-radius: 0px;
  line-height: 27px !important;
  // border-bottom: 2px solid #e0e0e0;
  padding: 10px;
  padding-bottom: 26px;
  position: relative;
  right: 6px;
  color: white;
  & > .date {
    position: absolute;
    right: 8px;
    bottom: 0px;
    font-size: 11px;
  }
  & > .file {
    display: flex;
    align-items: center;
  }
  & > .file > a {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    & > svg {
      color: ${theme.palette.primary.dark} !important;
      font-size: 27px;
    }
  }
  & > .arrow {
    border-top: 7px solid transparent;
    border-left: 7px solid #04c1f3;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #04c1f3;
    position: absolute;
    right: -11px;
    bottom: 0;
  }
`;

export const StyledTypographyAdmin = styled.div`
  // min-height: 35px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 2;
  // -moz-box-orient: vertical;
  background: rgb(229, 247, 252);
  display: inline-block;
  width: auto;
  max-width: 80%;
  min-width: 160px;
  margin-bottom: 10px;
  margin-left: 10px;
  border-radius: 20px;
  border-bottom-left-radius: 0px;
  line-height: 27px !important;
  // border-bottom: 2px solid #e0e0e0;
  padding: 10px;
  padding-bottom: 26px;
  position: relative;
  left: 6px;
  color: black;
  & > .date {
    position: absolute;
    left: 8px;
    bottom: 0px;
    font-size: 11px;
  }
  & > .file {
    display: flex;
    align-items: center;
  }
  & > .file > a {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    & > svg {
      color: ${theme.palette.primary.dark} !important;
      font-size: 27px;
    }
  }
  & > .arrow {
    border-top: 7px solid transparent;
    border-left: 7px solid transparent;
    border-right: 7px solid rgb(229, 247, 252);
    border-bottom: 7px solid rgb(229, 247, 252);
    position: absolute;
    left: -10px;
    bottom: 0;
  }
`;

export const StyledContainerBox = styled.div`
  width: 100% !important;
  position: relative !important;
  & .MuiOutlinedInput-root label,
  & .MuiOutlinedInput-root div,
  & .MuiOutlinedInput-root input,
  & .MuiOutlinedInput-root fieldset {
    opacity: 0 !important;
  }
`;
export const StyledUploadBox = styled.div`
  width: 100% !important;
  height: 100% !important;
  color: ${(props) =>
    props.file ? (props.error ? "#d32f2f" : "black") : "rgba(0, 0, 0, 0.6)"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  border: 1px solid
    ${(props) => (props.error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)")};
  border-radius: 5px;
  padding: 5.1px 14px;
  & svg {
    color: ${theme.palette.primary.main};
    font-size: 24px;
    margin: 0px !important;
    padding: 0px !important;
  }
`;
export const StyledChoiceFileText = styled.span`
  max-width: 100% !important;
  color: #333 !important;
  font-size: 17px !important;
  margin: 0px !important;
  padding: 0px !important;
`;
